var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2"},[_c('Button',{attrs:{"name":"Limpar filtros","type":"fill","action":"buttonLimparFiltrosClick","toggledButton":false},on:{"buttonLimparFiltrosClick":_vm.buttonLimparFiltrosClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }